// extracted by css-extract-rspack-plugin
export default {"sklandReturn":"hPot9H","skland":"GWTaMN"};